import { useAuthStore } from '@/modules/auth/store'


const isAuthenticatedGuard = async( to, from, next ) => {

    const authStore = useAuthStore()
    const { ok } = await authStore.checkAuthentication()

    if ( ok ) next()
    else next({ name: 'login' })
}

export default isAuthenticatedGuard